import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { DialogService, DialogComponent } from 'ng2-bootstrap-modal';
import { AgentProfile } from '../../_models/agent.profile';
import { SHAREDCONSTANTS } from '../../_constants/constants';
import { NotificationDialogComponent } from './../../notification/notification.dialog.component';

import { TranslatePipe } from '../../shared/translate/translate.pipe';
import { TranslateService } from '../../_services/translate.service';
import { LoaderService } from '../../_services/loader.service';
import { SuccessfullLoginService } from '../../_services/successfull.login.service';

export interface SuccessfullLoginModel {
    subValue: string;
    opcoValue: string;
    selectedCountry:string;
    agentprofile: AgentProfile;
    lastLoginService: SuccessfullLoginService;
}

@Component({
    templateUrl: 'mc.successfull.login.component.html',
    providers: [TranslatePipe]
})

export class SuccessfullLogin extends DialogComponent<SuccessfullLoginModel, string> implements SuccessfullLoginModel, OnInit {
  
    lastLoginService: SuccessfullLoginService;
    subValue: string;
    opcoValue: string;
    selectedCountry: string;
    agentprofile: AgentProfile;    

    page: number = 1;
    totalItems: number;
    lastLoginData: any = [];
    itemsPerPage : number = 10;
    isLoading:Boolean = false;
    offset:number = 0;
    recordStart:number = 0;
    recordEnd:number;
    currentPageItemsLength:number;
    fromDeleteAction:boolean = false;
    

    constructor(private ds: DialogService, private cdRef:ChangeDetectorRef, private translatePipe: TranslatePipe, private translateService: TranslateService, private loaderService: LoaderService) {
          super(ds);
    }

     ngOnInit(){
       this.fromDeleteAction = false;
        setTimeout(() => {
            this.getLastLoginData(1);
        });         
     }

      ngAfterViewChecked()
      {        
       
        this.lastLoginData = this.lastLoginData;
        this.isLoading = this.isLoading;
        this.totalItems = this.totalItems;
        this.page = this.page;
        this.fromDeleteAction = this.fromDeleteAction;
      }

      getLastLoginData = (event) => {        
      
        this.isLoading = true;
        this.loaderService.display(true);

        this.offset = (event - 1) * this.itemsPerPage;
        
        
        this.lastLoginService.getLastSuccessfullLoginData(event, this.subValue, this.opcoValue, this.itemsPerPage, this.offset).subscribe(
          (data) => {      
              this.page = event;              
              this.lastLoginData = data.items.sort((a: any, b: any) => new Date(b.timeOfRequest).getTime() - new Date(a.timeOfRequest).getTime()),
              this.totalItems = data.totalItems,
              this.isLoading = false,
              this.recordStart = (this.offset) + 1;
              this.recordEnd = (this.offset + this.itemsPerPage) - (this.itemsPerPage - parseInt(this.lastLoginData.length));
              this.currentPageItemsLength = this.lastLoginData.length;
              this.loaderService.display(false);
                                      
          },
          (err) => {
                this.lastLoginData = [];                              
                this.isLoading = false;
                this.loaderService.display(false);

                if((!this.fromDeleteAction) && (this.translateService.checkAPIErrorExistsByCode(err.json().internalCode))){
                    this.ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: this.translatePipe.transform(err.json().internalCode,'API_ERROR')                   
                    });
                }
                else if(err.json().internalCode && this.translateService.checkAPIErrorExistsByCode(err.json().internalCode)){

                  if(this.fromDeleteAction && err.json().internalCode == "NOT_FOUND"){
                    console.log("From delete action");
                  }
                  else{

                    this.ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: new TranslatePipe(this.translateService).transform(err.json().internalCode,'API_ERROR')                   
                    });
                  }                    
                }
                else{
                    this.ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: this.translatePipe.transform("COMMON_ERROR_MESSAGE",'SHAREDCONSTANTS')
                    });
                }                               
          },
          () => {
          }
        );

        return event;
  }
}



// WEBPACK FOOTER //
// ./src/app/details/mc-successfull-login/mc.successfull.login.component.ts